import { render, staticRenderFns } from "./PlanetaryRevelation.vue?vue&type=template&id=f19f4b3c"
import script from "./PlanetaryRevelation.vue?vue&type=script&lang=js"
export * from "./PlanetaryRevelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports